<div>
	<div>
		<p-table
			#mydt
			[value]="lstUsers"
			[loading]="IsLoading()"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedUsers"
			dataKey="UserID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th></th>

					<!--Username-->
					<th>
						<p-columnFilter type="text" field="Username" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--StaffID-->
					<th>
						<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--FirstName-->
					<th>
						<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--LastName-->
					<th>
						<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th>
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>
					<th pSortableColumn="Username">User<p-sortIcon field="Username"></p-sortIcon></th>
					<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
					<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
					<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-User>
				<tr [pSelectableRow]="User">
					<td>
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="User" [value]="User"></p-tableCheckbox>
					</td>
					<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ User[col.field] }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<div class="Buttons">
	<label style="color: blue">{{ SelectedUsers.length }} Selected</label>
</div>

<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
